import find from 'lodash/find';
import React, { FC } from 'react';
import styled from 'styled-components';

import { DueStatus } from 'src/actions/rules/trigger';
import Input, { InputType } from 'src/presentation/components/forms/Input';
import {
  StyledDropdown,
  StyledInformationIcon,
  StyledTooltip,
} from 'src/presentation/components/pages/rules/shared/StyledComponents';

type DueInSectionProps = {
  value: { status: DueStatus; minutes: number };
  onDueStatusChange: Function;
  onMinutesChange: Function;
};

const DueInSection: FC<DueInSectionProps> = ({ value, onDueStatusChange, onMinutesChange }) => {
  return (
    <StyledSection>
      <StyledDueDropdown
        data-aid={'dueInSection-dropDown'}
        onSelect={onDueStatusChange}
        options={statusOptions}
        value={value.status}
      />
      {renderMinutes()}
    </StyledSection>
  );

  function renderMinutes() {
    if (value.status === DueStatus.Overdue) return null;

    const isPlural = value.minutes !== 1;
    return (
      <StyledMinutes>
        <StyledInput
          attr="minutes"
          data-aid={'dueInSection-minutesInput'}
          onChange={onMinutesChange}
          type={InputType.number}
          value={value.minutes.toString()}
        />
        <div>
          <StyledTooltip message="Value must be a positive number">
            <StyledInformationIcon />
          </StyledTooltip>
        </div>
        <StyledMinuteLabel>{`Minute${isPlural ? 's' : ''}`}</StyledMinuteLabel>
      </StyledMinutes>
    );
  }
};

const statusOptions: { label: string; value: string }[] = [
  { label: 'Due in', value: DueStatus.DueIn },
  { label: 'Overdue', value: DueStatus.Overdue },
  { label: 'Overdue by', value: DueStatus.OverdueBy },
];

export function getDueInStatusLabel(value: string): string {
  const status = find(statusOptions, { value });
  return status ? status.label : '';
}

const StyledSection = styled.div`
  display: flex;
  flex: 1 0 auto;
`;

const StyledMinutes = styled.div`
  align-items: center;
  display: flex;
  flex: 0;
`;

const StyledMinuteLabel = styled.div`
  display: flex;
  flex: 1;
`;

const StyledDueDropdown = styled(StyledDropdown)`
  flex: 0 1 110px;
`;

const StyledInput = styled(Input)`
  flex: 0;
  margin-left: 12px;
  margin-right: 12px;
  width: 50px;
`;

export default DueInSection;
